import { CtResponse, zget, zhttp } from "../Fetch";
import { poly } from "../schemas/mg.schema";

export class Poly {
	async getPoly(uid: string, params: any): Promise<CtResponse<poly[]>> {
		const r = await zget(`/users/${uid}/poly`, params);
		return r;
	}

	// ya
	async createPoly(uid: string, params: { token: string; name: string; lastname: string; email: string; phone: string; dpi: string; position: string; tags: string[] }) {
		const r = await zhttp(`/users/${uid}/poly`, "POST", params);
		return r;
	}

	async getPolyAdmin(uid: string, params: { pdf: string | null; tags?: string; limit?: string; skip?: string; token: string }): Promise<CtResponse<poly[]>> {
		const r = await zget(`/poly`, params);
		return r;
	}

	async editPolyAdmin(_id: number, params: { pdf?: string | null; recommendable?: boolean; token: string }): Promise<CtResponse<poly[]>> {
		const r = await zhttp(`/poly/${_id}`, "PUT", params);
		return r;
	}
}
